import {
  FETCH_CARE_HEARTH_INSIGHT,
  FETCH_CARE_HEARTH_INSIGHT_FAILURE,
  FETCH_CARE_HEARTH_INSIGHT_SUCCESS,
  FETCH_CARE_HEARTH_INSIGHTS,
  FETCH_CARE_HEARTH_INSIGHTS_FAILURE,
  FETCH_CARE_HEARTH_INSIGHTS_SUCCESS,
} from "./constants";

const action = (type) => (payload) => ({ type, payload });

export const fetchCareHearthInsights = action(FETCH_CARE_HEARTH_INSIGHTS);
export const fetchCareHearthInsightsSuccess = action(
  FETCH_CARE_HEARTH_INSIGHTS_SUCCESS,
);
export const fetchCareHearthInsightsFailure = action(
  FETCH_CARE_HEARTH_INSIGHTS_FAILURE,
);
export const fetchCareHearthInsight = action(FETCH_CARE_HEARTH_INSIGHT);
export const fetchCareHearthInsightSuccess = action(
  FETCH_CARE_HEARTH_INSIGHT_SUCCESS,
);
export const fetchCareHearthInsightFailure = action(
  FETCH_CARE_HEARTH_INSIGHT_FAILURE,
);
